var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.95 0.0146484V2.03465C15.34 2.57465 18.45 6.56465 17.91 10.9546C17.45 14.5946 14.59 17.4846 10.95 17.9146V19.9146C16.45 19.3646 20.45 14.4846 19.9 8.98465C19.45 4.23465 15.68 0.484648 10.95 0.0146484ZM8.95 0.0446484C7 0.234648 5.14 0.984649 3.62 2.24465L5.05 3.72465C6.17 2.82465 7.52 2.24465 8.95 2.04465V0.0446484ZM2.21 3.65465C0.959656 5.17199 0.190202 7.02773 0 8.98465H2C2.19 7.56465 2.75 6.21465 3.64 5.08465L2.21 3.65465ZM13.45 6.48465L8.57 11.3646L6.45 9.24465L5.39 10.3046L8.57 13.4846L14.51 7.54465L13.45 6.48465ZM0.00999999 10.9846C0.21 12.9446 0.98 14.7946 2.22 16.3146L3.64 14.8846C2.75693 13.7542 2.19395 12.4072 2.01 10.9846H0.00999999ZM5.05 16.3546L3.62 17.7246C5.13478 18.9873 6.98927 19.7737 8.95 19.9846V17.9846C7.5274 17.8007 6.1804 17.2377 5.05 16.3546Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressIcon);
export default __webpack_public_path__ + "static/media/in-progress-icon.faced005ca33ff939d51e809ea7865ee.svg";
export { ForwardRef as ReactComponent };